const Info = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0 2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm1-12v7h-2v-7h2zm-1-3a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" fill="#000" />
    </svg>
)
export default Info;